<script>
	let ref;
	$: ref && document.body.prepend(ref);
</script>

<div bind:this={ref}>
	<slot></slot>
</div>